import { createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../../services/api'
import buildQuery from 'odata-query'
import _ from 'lodash'
import { getUserFactoryId } from '../../../../index';
import { updateFunnel , fetchDataView } from './FunnelCrud.js'

export const FUNEL_URL = '/funil'

export const featchFunelList = createAsyncThunk(
    'funil/featchFunelList',
    async (args, { rejectWithValue, getState }) => {
        const { funnel } = getState()
        
        let filter = {
            'structure/factoryId': { eq: parseInt(getUserFactoryId()) }
        }
        if ( _.has(funnel, 'filters.structureId') && ! _.isEmpty( funnel.filters.structureId ) ) {
            filter = _.merge(filter, {
                structureId: {
                    in: _.get(funnel, 'filters.structureId')
                }
            })
        }

        if (_.has(funnel, 'filters.status')) {
            if (_.get(funnel, 'filters.status') == true) {
                filter = _.merge(filter, {
                    status: 0
                })
            }
            else {
                filter = _.merge(filter, {
                    status: 1
                })
            }
        }
        else {            
            filter = _.merge(filter, {
                status: 1
            })
        }

        if ( _.has(funnel, 'filters.GTA') && ! _.isEmpty( funnel.filters.GTA ) ) {
            filter = _.merge(filter, {
                GTAUser: {
                    name: {
                        contains: _.get(funnel, 'filters.GTA')
                    }
                }
            })
        }

        if ( _.has(funnel, 'filters.GTM') && ! _.isEmpty( funnel.filters.GTM ) ) {
            filter = _.merge(filter, {
                GTMUser: {
                    name: {
                        contains: _.get(funnel, 'filters.GTM')
                    }
                }
            })
        }

        if ( _.has(funnel, 'filters.activity') && ! _.isEmpty( funnel.filters.activity ) ) {
            filter = _.merge(filter, {
                FunilActivities: {
                    any: {activity: {
                        contains: _.get(funnel, 'filters.activity')
                    }}
                }
            })
        }

        if ( _.has(funnel, 'filters.typeActivity') && ! _.isEmpty( funnel.filters.typeActivity ) ) {
            console.log(_.get(funnel, 'filters.typeActivity'));
            if (_.get(funnel, 'filters.typeActivity') !== "Todos") {
                filter = _.merge(filter, {
                    FunilActivities: {
                        any: {type: 
                             _.get(funnel, 'filters.typeActivity')
                        }
                    }
                })
            }
            
        }
        //console.log("filter",filter)

        const response = await api.get(`${FUNEL_URL}/odata/${buildQuery({
            filter,
            select: ['*'],
            expand:{
                structure: {
                    select: ['name']
                },
                GTMUser:{
                    select:['name']
                },
                GTAUser:{
                    select:['name']
                }
            },
            skip: ( funnel.pagination.page - 1 ) * funnel.pagination.sizePerPage,
            top: funnel.pagination.sizePerPage,
            count: true
        })}`)

        //console.log(response)

        if ( response.status !== 200 ) {
            rejectWithValue(response.statusText)
        }

        return {
            total: response.data._count,
            entities: response.data.value
        }
    }
)

export async function DisablerActivateFunnelAPI(idFunnel, desativarAtivar){
	let Funnel = await fetchDataView(idFunnel);
	let body = {
        "createdAt": Funnel.data.createdAt,
        "gtaUserId": Funnel.data.gtaUserId,
        "gtmUserId": Funnel.data.gtmUserId,
        "structureId": Funnel.data.structureId,
		"status": desativarAtivar,
		"id": idFunnel
	  }
	  
	  let retorno = await updateFunnel(body);

	  return retorno;
};